/* eslint-disable @typescript-eslint/no-explicit-any */
import { FirestoreError } from 'firebase/firestore';

import { GoogleMessageObject, GTMEventTypes } from '@types';

export interface UsState {
  label: string;
  value: string;
}
export type commonModule =
  | 'MODULE_INTRO'
  | 'MODULE_REVIEW'
  | 'MODULE_RESULT_OPTIONS';

export const RESERVED_MODULES: string[] = [
  'MODULE_INTRO',
  'MODULE_RESULT_OPTIONS',
  'MODULE_REVIEW',
];

export type SubModule =
  | 'SUBMODULE_NAME'
  | 'SUBMODULE_STATE'
  | 'SUBMODULE_ZIPCODE'
  | 'SUBMODULE_CONTACT'
  | 'SUBMODULE_DEBT_GOAL'
  | 'SUBMODULE_DEBT_AMOUNT'
  | 'SUBMODULE_DEBT_TYPES'
  | 'SUBMODULE_PAYMENT_STATUS'
  | 'SUBMODULE_EMPLOYMENT_STATUS'
  | 'SUBMODULE_CREDIT_SCORE'
  | 'SUBMODULE_HOUSEHOLD_INCOME'
  | 'SUBMODULE_INCOME'
  | 'SUBMODULE_INCOME_CONSISTENCY'
  | 'SUBMODULE_DEBT_CAUSE'
  | 'SUBMODULE_CREDIT_SCORE_IMPORTANCE'
  | 'SUBMODULE_PROPERTY_TYPE'
  | 'SUBMODULE_FUTURE_LOANS';

export type EvaluationName = string;

export type EventName =
  | 'conversion'
  | 'close'
  | 'finish'
  | 'loaded'
  | 'analyticsReady'
  | 'formReady'
  | 'screenReady'
  | 'finish'
  | 'set_title'
  | 'submission'
  | 'progress_to_host'
  | 'error'
  | 'exit'
  | 'error_button_clicked'
  | 'offer_digital_enrollment'
  | 'opted_for_digital_enrollment'
  | 'digital_opt_in_declined'
  | 'redirect'
  | 'consentUpdate'
  | GTMEventTypes;

export interface ConversionEventData {
  leadid?: string;
  leadType?: string;
  leadguid?: string;
  error?: FirestoreError | Error;
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  zipCode?: string;
  language?: string;
  debtamount?: number;
}

export enum IssueDetectedVariant {
  FALLBACK = 'fallback',
  DOES_NOT_QUALIFY = 'doesNotQualify',
  DUPLICATE_LEAD = 'duplicateLead',
}

export enum ResultOptiontagnum {
  MATCH = 'Match',
  BEST_MATCH = 'Best Match',
  POSSIBLE_MATCH = 'Possible Match',
  LAST_RESORT = 'Last Resort',
}

export interface EventData {
  name: EventName;
  title?: string;
  engagement?: EngagementIdObjectToHostData;
  data?:
    | (Partial<GoogleMessageObject> & ConversionEventData)
    | ProgressToHostEventData;
  error?: Error;
}

export type LanguageHeaders = {
  en: {
    title?: string;
    description?: string;
  };
  es: {
    title?: string;
    description?: string;
  };
};

export interface Module {
  name: string;
  title: string;
  subModules: string[];
  events?: string[];
  showBackBtn?: boolean;
  headers?: LanguageHeaders;
}

export interface Variant {
  modules: Module[];
}

export interface SelectOption {
  label: string;
  value: string;
}

export type Options<T> = Array<{
  label: string;
  value: T;
}>;

export interface Partner {
  createdate?: string;
  createdby?: string;
  displayname?: string;
  id?: string;
  lastupdate?: string;
  name?: string;
  status?: string;
  token?: string;
  updatedby?: string;
  reference_id?: string;
  mode?: Mode;
  ida_saas_redirect_url?: string;
  Logo_FullColor_notagline_32px?: string;
  Logo_FullColor_wtagline_64px?: string;
  Logo_FullColor_eswtagline_64px?: string;
  Logo_MonoColorWhite_notagline_48px?: string;
  idaLogo?: string;
  whiteLabelToggle?: boolean;
  forceQualification?: boolean;
  terms_url?: string;
  esign_url?: string;
  privacy_url?: string;
  terms_url_es?: string;
  esign_url_es?: string;
  privacy_url_es?: string;
  arbitration_url?: string;
  arbitration_url_es?: string;
}

export enum LegalKeys {
  PRIVACY_POLICY = 'privacyPolicy',
  ESIGN_DISCLOSURE = 'esignDisclosure',
  TERMS_OF_USE = 'termsOfUse',
  ARBITRATION_AGREEMENT = 'arbitrationAgreement',
}

export interface LegalTerms {
  tcpaEn: string;
  tcpaEs: string;
  copyright: string;
}

export interface Logos {
  headerLogo?: string;
  tagLineLogo?: string;
  whiteLogo?: string;
}

export interface Program {
  active: boolean;
  id: string;
  name: string;
  savings_rule_id?: string | null;
}

type Mode = 'live' | 'test';
export type IntroTypes = '' | 'none' | 'DCOM_01' | 'COBRANDED_01';

export type LoaderInitializationOptions = {
  name?: string;
  campaignCallNumber?: string;
  pid?: string;
  gaClientId?: string;
  consentCookie?: string;
  ecStartButtonId?: string;
  language?: string;
  passthroughParams?: any;
  requestingHost?: string;
  requestingHostLong?: string;
  introUI?: IntroTypes;
  dataToken?: string;
  token?: string;
  variant?: string;
  hostUrl?: string;
  showGenericAnimation?: boolean;
};

export interface EngagementIdObjectToHostData {
  id?: string;
  redirectUrl?: string;
}

export interface ProgressToHostEventData {
  moduleTitle: string;
  percentComplete?: number;
}

export type LanguageOptions = 'en' | 'es';
export interface InitializeParams {
  name: 'initialize';
  language: LanguageOptions;
  token: string;
}
export type EditMode = { editMode?: boolean };

export interface MapiResponse {
  Status?: 'Success' | 'Errors';
  LeadId?: string;
  LeadGUID?: string;
  APIResponse?: string;
  APIResponseType?: string;
  Errors?: string[];
}

export type ResultOptionTag =
  (typeof ResultOptiontagnum)[keyof typeof ResultOptiontagnum];
export const CONSENT_SELECTION = 'cookie-consent';
export const CONSENT_SELECTION_ACC = 'accepted';
export const CONSENT_SELECTION_DEC = 'declined';

export const GA_CLIENT_ID = 'ga-client-id';
// We already have one called _dcomCookieConsent with values: disclosure_closed, disclosure_accepted, and disclosure_rejected
export const DEBT_CONSENT_SELECTION = '_dcomCookieConsent';
export const DEBT_CONSENT_SELECTION_ACC = 'disclosure_accepted';
export const DEBT_CONSENT_SELECTION_DEC = 'disclosure_rejected';

export interface RetryFailureError extends Error {
  isRetryFailure: true;
  attempts: number;
}
